

const BiegungCard = (props) => {
    return(
        <>
        <div className="col-2 posi-col-2">
            <div className="Card-container">
                <img alt="Bild Biegefall"src={props.FallIMG}></img>
                <div className="werte-container">
                <p><b>fx:</b> {props.fx.toFixed(3)} mm</p>
                <p><b>fy:</b> {props.fy.toFixed(3)} mm</p>
                <p><b>σx:</b>  {props.BSPx.toFixed(3)} N/mm<sup>2</sup></p>
                <p><b>σy:</b> {props.BSPy.toFixed(3)} N/mm<sup>2</sup></p>
                </div>
            </div>
        </div>
        </>
    );
}


export default BiegungCard;